import { StyledIcon } from 'components/elements/Icon/Icon.styled';
import { IconButton } from 'components/elements/IconButton';
import { styled } from 'styles';

export const FullscreenCloseButton = styled(IconButton).attrs({
  icon: 'close',
  variant: 'transparent',
})`
  border-radius: 50%;
  font-size: 1.5em;
  height: 1.4em;
  width: 1.4em;

  ${StyledIcon} {
    font-size: 1em;
  }
`;

export const FullscreenCloseButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  padding: ${({ theme }) => theme.spacing.absolute.medium}
    ${({ theme }) => theme.spacing.absolute.larger};
`;

export const FullscreenContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

export const FullscreenPanel = styled.div`
  background-color: ${({ theme }) => theme.fullscreen.panel.background};
  border-radius: ${({ theme }) => theme.radius.medium};
  box-shadow: ${({ theme }) => theme.shadow.medium};
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

export const StyledFullscreen = styled.div`
  background-color: ${({ theme }) => theme.fullscreen.background};
  display: flex;
  height: 100vh;
  left: 0;
  padding: ${({ theme }) => theme.spacing.absolute.medium};
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 9;
`;

FullscreenCloseButton.displayName = 'FullscreenCloseButton';
FullscreenCloseButtonWrapper.displayName = 'FullscreenCloseButtonWrapper';
FullscreenContent.displayName = 'FullscreenContent';
FullscreenPanel.displayName = 'FullscreenPanel';
StyledFullscreen.displayName = 'Fullscreen.Styled';
